import Vocabulary from './component';
import _routes from './routes';

export const routes = _routes;

export default Vocabulary;



// WEBPACK FOOTER //
// ./containers/Group/Homework/Vocabulary/index.js